import { createFileRoute, redirect } from '@tanstack/react-router'
import { interventionKeys } from '@/hooks/interventions/query-keys'
import { listInterventions } from '@/api/interventions-api'
import { prefetchInterventionFull } from '@/hooks/interventions/requests/useGetInterventionFull'
import { InterventionDetailSkeleton } from '@/components/interventions/intervention-detail-skeleton'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/interventions/'
)({
  pendingComponent: InterventionDetailSkeleton,
  pendingMinMs: 0,
  loader: async ({ params: { orgId }, context: { queryClient } }) => {
    const result = await queryClient.ensureQueryData({
      queryKey: interventionKeys.list(orgId),
      queryFn: () => listInterventions(),
    })

    // Redirect to first intervention if available
    if (result?.data && result.data.length > 0) {
      const firstInterventionId = result.data[0].id

      // Preload first intervention aggregate data
      prefetchInterventionFull(queryClient, firstInterventionId)

      // Redirect after data is loaded
      throw redirect({
        to: '/org/$orgId/interventions/$interventionId',
        params: {
          orgId,
          interventionId: firstInterventionId,
        },
        search: {
          tab: 'details',
        },
        replace: true,
      })
    }

    return result
  },
})
